import * as types from './mutation-types'
import { getService } from '../api/service'
import { getProfile } from '../api/profile'
import Vue from 'vue'
import { defaultStore } from '../library/firebase'

// 공용으로 사용할 저장소
const state = {
  service: {
    detail: {},
    profile: {},
    reservations: {}
  }
}

// 데이터 읽기만 수행
const getters = {
  serviceDetail: state => state.service.detail,
  serviceProfile: state => state.service.profile
}

// 테이터 가져오는 역할
const actions = {
  async [types.GET_SERVICE_DETAIL]({ commit }, payload = {}) {
    getService(payload.serviceId).then(service => {
      if (service) {
        console.log('GET_SERVICE:', service)
        commit(types.SET_SERVICE, { name: 'detail', value: service })
        getProfile(service.uid).then(profile => {
          console.log('get api profile:', profile)
          if (payload.uid) {
            defaultStore
              .collection('saved_lists')
              .where('saveUid', '==', payload.uid)
              .where('serviceId', '==', payload.serviceId)
              .get()
              .then(snap => {
                // console.log('check snap', snap)
                const result = []
                snap.forEach(v => {
                  result.push(v.id)
                })
                commit(types.SET_SERVICE, {
                  name: 'profile',
                  value: Object.assign(profile, { saved: result })
                })
              })
          } else {
            commit(types.SET_SERVICE, {
              name: 'profile',
              value: Object.assign(profile, { saved: [] })
            })
          }
        })
      } else {
        alert('no data')
      }
    })
  },
  [types.RESET_SERVICE]({ commit }) {
    commit(types.SET_SERVICE, { name: 'detail', value: '' })
    commit(types.SET_SERVICE, { name: 'profile', value: '' })
  }
}
// 데이터 변형에 대한 부분
const mutations = {
  [types.SET_SERVICE](state, result) {
    Vue.set(state.service, result.name, result.value)
    // Object.assign(state.service[result.name], result.value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
